
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/benny-joo-joining",
      function () {
        return require("private-next-pages/blog/benny-joo-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/benny-joo-joining"])
      });
    }
  